import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

export default function EditAdvance({editedAdvanceId, availableWorkers}) {
    const [saveButtonDisable, setSaveButtonDisable] = useState(false);
    const [saveStatus, setSaveStatus] = useState("");
    const api_url = process.env.REACT_APP_API_URL;
    const complexName = localStorage.getItem('complex_name');
    const role = localStorage.getItem('role');
    const [advanceId, setAdvanceId] = useState("");
    const [advanceAmount, setAdvanceAmount] = useState("");
    const [complexName2, setComplexName2] = useState("");
    const [workerId, setWorkerId] = useState("");
    const [userId, setUserId] = useState("");
    const [recipientType, setRecipientType] = useState("worker");
    const [comment, setComment] = useState("");
    const [advanceDate, setAdvanceDate] = useState("");
    const [availableAdmins, setAvailableAdmins] = useState([]);

    useEffect(() => {
        async function getAdvanceInfo() {
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify({ advance_id: editedAdvanceId })
          };
          const advance = await (await fetch(api_url+"/api/advanceInfo", requestOptions)).json();

          setAdvanceId(advance.advance_id);
          setAdvanceAmount(advance.advance_amount);
          setComplexName2(advance.complex_name);
          setRecipientType(advance.recipient_type || 'worker');
          setWorkerId(advance.worker_id || "");
          setUserId(advance.user_id || "");
          setComment(advance.comment);

          if (advance.advance_date) {
            const date = new Date(advance.advance_date);
            const formattedDate = date.toISOString().split('T')[0];
            setAdvanceDate(formattedDate);
          }
        }

        async function getAvailableAdmins() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
              body: JSON.stringify({ complex_name: complexName })
            };
            const body = await (await fetch(api_url+"/api/availableAdmins", requestOptions)).json();
            setAvailableAdmins(body.map(({ user_id, fullname }) => ({ userId: user_id, fullName: fullname })));
        }

        getAdvanceInfo();
        getAvailableAdmins();
    }, []);

    async function updateAdvanceInfo() {
        setSaveButtonDisable(true);

        const requestBody = {
            advance_id: advanceId,
            advance_amount: advanceAmount,
            complex_name: complexName2,
            recipient_type: recipientType,
            comment: comment
        };

        if (recipientType === 'user') {
            const user_info = availableAdmins.find((s) => s.userId === userId);
            requestBody.user_id = userId;
            requestBody.user_name = user_info ? user_info.fullName : "";
        } else {
            const worker_info = availableWorkers.find((s) => s.workerId === workerId);
            requestBody.worker_id = workerId;
            requestBody.worker_name = worker_info ? worker_info.fullName : "";
        }

        if (role === "2" && advanceDate) {
            requestBody.advance_date = advanceDate;
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify(requestBody)
        };

        const saving_advance = await fetch(api_url+"/api/updateAdvanceInfo", requestOptions);

        const body = await saving_advance.json();
        if (body.message === "Advance info updated successfully!") {
          setSaveStatus("success");
        }
        else {
          setSaveStatus("error");
          setSaveButtonDisable(false);
        }
    }

    return (
        <div className='edit-worker-modal'>
            <h1 className="modal-header"> Изменить информацию о авансе </h1>
            <Box sx={{ maxWidth: 550, margin: `auto`, pt: 5, pb: 5 }}>
            <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel id="recipient-type-label">Тип получателя:</InputLabel>
            <Select
                value={recipientType}
                label="Тип получателя:"
                onChange={e => {
                    setRecipientType(e.target.value);
                    setWorkerId("");
                    setUserId("");
                }}
            >
                <MenuItem value="worker">Мойщик/Кассир/КК</MenuItem>
                <MenuItem value="user">Админ/HR-директор</MenuItem>
            </Select>
            </FormControl>

            <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel id="recipient-select-label">Сотрудник:</InputLabel>
            <Select
                value={recipientType === 'user' ? userId : workerId}
                label="Сотрудник:"
                name="recipientId"
                fullWidth
                onChange={e => {
                    if (recipientType === 'user') {
                        setUserId(e.target.value);
                    } else {
                        setWorkerId(e.target.value);
                    }
                }}
            >
                {recipientType === 'user'
                    ? availableAdmins.map(({userId, fullName}) => (
                        <MenuItem key={userId} value={userId}> {fullName} </MenuItem>
                      ))
                    : availableWorkers.map(({workerId, fullName}) => (
                        <MenuItem key={workerId} value={workerId}> {fullName} </MenuItem>
                      ))
                }
            </Select>
            </FormControl>

            <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel htmlFor="component-outlined">Размер аванса</InputLabel>
            <OutlinedInput
                label="Размер аванса"
                name="advanceAmount"
                value={advanceAmount}
                onChange={e => setAdvanceAmount(e.target.value)}
            />
            </FormControl>

            <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
            <InputLabel htmlFor="component-outlined">Комментарий</InputLabel>
            <OutlinedInput
                label="Комментарий"
                name="comment"
                value={comment}
                onChange={e => setComment(e.target.value)}
            />
            </FormControl>

            {role === "2" && (
            <TextField
                sx={{mb:1.5, mt:1.5}}
                fullWidth
                label="Дата аванса"
                type="date"
                value={advanceDate}
                onChange={(e) => setAdvanceDate(e.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            )}

            <Button variant="contained"
                sx={{mb:1.5, mt:1.5}} fullWidth
                disabled={saveButtonDisable}
                color="success"
                className="mr10"
                onClick={() => updateAdvanceInfo()}>Сохранить изменения</Button>

    {saveStatus === "error" && <Alert severity="error">Ошибка, проверьте правильность введенных данных!</Alert>}
    {saveStatus === "success" && <Alert severity="success">Изменения успешно сохранены!</Alert>}
    </Box>
        </div>
    );
}
